// ── GIF Manifest — static, built from public/athena-assets/gifs/ ──────────────
export const GIF_BASE = './athena-assets/gifs';

export const GIF_MANIFEST = {
  'abraco':      ['media_1781525980929.mp4','media_1781525984710.mp4','media_1781525999879.mp4','media_1781526089263.mp4','media_1781526112926.mp4','media_1781528825315.mp4','media_1781528862794.mp4','media_1781528916548.mp4','media_1781528965113.mp4','media_1781528970828.mp4'],
  'agradecendo': ['media_1781525909176.mp4','media_1781525988294.mp4','media_1781526089263.mp4','media_1781528825315.mp4','media_1781528857780.mp4','media_1781528862794.mp4','media_1781528988603.mp4','media_1781529000730.mp4','media_1781529049371.mp4','media_1781529099611.mp4'],
  'boa-noite':   ['media_1781525870441.mp4','media_1781525903610.mp4','media_1781528778649.mp4','media_1781528945597.mp4','media_1781529035339.mp4','media_1781529088385.mp4','media_1781529114091.mp4','media_1781529144132.mp4','media_1781529156900.mp4','media_1781529197145.mp4'],
  'boa-tarde':   ['media_1781525870441.mp4','media_1781528798387.mp4','media_1781528921061.mp4','media_1781528957620.mp4','media_1781528995061.mp4','media_1781529206147.mp4'],
  'bom-dia':     ['media_1781525859025.mp4','media_1781525870441.mp4','media_1781525903610.mp4','media_1781525917240.mp4','media_1781525975809.mp4','media_1781526024135.mp4','media_1781526056904.mp4','media_1781526089263.mp4','media_1781528636303.mp4','media_1781528952190.mp4','media_1781528965113.mp4','media_1781529156900.mp4','media_1781529197145.mp4','media_1781529216075.mp4','media_1781529234043.mp4'],
  'comemorando': ['media_1781525899023.mp4','media_1781525936495.mp4','media_1781525988294.mp4','media_1781526012110.mp4','media_1781526050323.mp4','media_1781526207575.mp4','media_1781528636303.mp4','media_1781528772167.mp4','media_1781528857780.mp4','media_1781528937711.mp4','media_1781529099611.mp4','media_1781529127565.mp4','media_1781529152732.mp4'],
  'curiosa':     ['media_1781525951104.mp4','media_1781526056904.mp4','media_1781528607917.mp4','media_1781529002310.mp4','media_1781529114091.mp4','media_1781529187312.mp4','media_1781529224118.mp4','media_1781529234043.mp4','media_1781529444283.mp4'],
  'engracado':   ['media_1781525847742.mp4','media_1781526046456.mp4','media_1781526053624.mp4','media_1781528829664.mp4','media_1781528888596.mp4','media_1781529049371.mp4','media_1781529167237.mp4','media_1781529206147.mp4'],
  'feliz':       ['media_1781526012110.mp4','media_1781526089263.mp4','media_1781528829664.mp4','media_1781528857780.mp4','media_1781528888596.mp4','media_1781529099611.mp4','media_1781529127565.mp4','media_1781529152732.mp4','media_1781529167237.mp4'],
  'motivando':   ['media_1781526112926.mp4','media_1781528839242.mp4','media_1781528965113.mp4','media_1781529144132.mp4','media_1781529174514.mp4','media_1781529191627.mp4'],
  'neutro':      ['media_1781497778965.mp4','media_1781497814066.mp4','media_1781525892380.mp4','media_1781525992290.mp4','media_1781525996572.mp4','media_1781526033150.mp4','media_1781526062314.mp4','media_1781526135197.mp4','media_1781528596964.mp4','media_1781528794082.mp4','media_1781528814315.mp4','media_1781528821735.mp4','media_1781528834019.mp4','media_1781528848048.mp4','media_1781528879278.mp4','media_1781528921061.mp4','media_1781528928429.mp4','media_1781528957620.mp4','media_1781528961713.mp4','media_1781528995061.mp4','media_1781529144132.mp4','media_1781529187312.mp4','media_1781529191627.mp4','media_1781529206147.mp4'],
  'pensando':    ['media_1781526070630.mp4','media_1781526135197.mp4','media_1781528948711.mp4','media_1781528995061.mp4','media_1781529002310.mp4','media_1781529127565.mp4','media_1781529200721.mp4','media_1781529230007.mp4'],
  'refletindo':  ['media_1781525955894.mp4','media_1781526070630.mp4','media_1781528948711.mp4','media_1781529002310.mp4','media_1781529174514.mp4','media_1781529187312.mp4','media_1781529200721.mp4','media_1781529216075.mp4','media_1781529230007.mp4'],
  'sono':        ['media_1781526085599.mp4','media_1781528701963.mp4','media_1781528945597.mp4','media_1781529035339.mp4','media_1781529040672.mp4','media_1781529053157.mp4','media_1781529088385.mp4','media_1781529107337.mp4','media_1781529133549.mp4','media_1781529160271.mp4','media_1781529187312.mp4'],
  'surpresa':    ['media_1781525959320.mp4','media_1781529224118.mp4','media_1781529238694.mp4'],
  'triste':      ['media_1781526003924.mp4','media_1781526037245.mp4','media_1781528616006.mp4','media_1781528677816.mp4','media_1781528711449.mp4','media_1781528854498.mp4','media_1781528873397.mp4','media_1781528941952.mp4','media_1781529148907.mp4'],
};

export const GIF_CATEGORIES = Object.keys(GIF_MANIFEST);

// ── Load social prefs from localStorage ──────────────────────────────────────
export function loadSocialPrefs() {
  try { return JSON.parse(localStorage.getItem('athena_social_prefs') || '{}'); } catch { return {}; }
}

// ── Pick a random file path from a category ──────────────────────────────────
export function pickGifPath(category) {
  const files = GIF_MANIFEST[category];
  if (!files || files.length === 0) return null;
  const file = files[Math.floor(Math.random() * files.length)];
  return `${GIF_BASE}/${category}/${file}`;
}

// ── shouldRenderGif — único gate de decisão antes de renderizar qualquer GIF ──
// social_prefs.gifsLevel é soberano. Nenhuma outra configuração pode sobrescrever.
let _lastGifRenderTime = 0;
const COOLDOWN_NATURAL_MS = 90_000;   // 90s entre GIFs automáticos no nível Natural
const COOLDOWN_MAX_MS     = 15_000;   // 15s entre GIFs automáticos no nível Máximo

const EXPLICIT_GIF_RE = /\b(mand[ae]\s*(?:um\s*)?gif|quero\s*(?:um\s*)?gif|us[ae]\s*gif|me\s*mand[ae]?\s*(?:um\s*)?gif|gif\s*(?:engraçado|fofo|legal|por\s*favor))\b/i;

export function shouldRenderGif({ gifCategory, socialPrefs, prevUserMsg = '' }) {
  if (!gifCategory) return false;

  // Normaliza: remove acentos para comparar 'Máximo' → 'maximo'
  const raw   = socialPrefs?.gifsLevel || 'Baixo';
  const level = raw.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const isExplicit = EXPLICIT_GIF_RE.test(prevUserMsg || '');
  const now = Date.now();

  // ── Baixo: somente se o usuário pediu explicitamente ──────────────────────
  if (level === 'baixo') {
    if (isExplicit) {
      console.log('[ATHENA GIF] allowed_explicit_request');
      _lastGifRenderTime = now;
      return true;
    }
    console.log('[ATHENA GIF] blocked_by_user_pref: low');
    return false;
  }

  // ── Natural: ocasional, com cooldown mínimo ───────────────────────────────
  if (level === 'natural') {
    if (isExplicit) {
      console.log('[ATHENA GIF] allowed_explicit_request');
      _lastGifRenderTime = now;
      return true;
    }
    const elapsed = now - _lastGifRenderTime;
    if (elapsed < COOLDOWN_NATURAL_MS) {
      console.log(`[ATHENA GIF] blocked_cooldown (${Math.round(elapsed / 1000)}s < ${COOLDOWN_NATURAL_MS / 1000}s)`);
      return false;
    }
    console.log('[ATHENA GIF] allowed_natural');
    _lastGifRenderTime = now;
    return true;
  }

  // ── Máximo: frequente, mas ainda com cooldown anti-spam ──────────────────
  if (isExplicit) {
    console.log('[ATHENA GIF] allowed_explicit_request');
    _lastGifRenderTime = now;
    return true;
  }
  const elapsed = now - _lastGifRenderTime;
  if (elapsed < COOLDOWN_MAX_MS) {
    console.log(`[ATHENA GIF] blocked_cooldown (${Math.round(elapsed / 1000)}s < ${COOLDOWN_MAX_MS / 1000}s)`);
    return false;
  }
  console.log('[ATHENA GIF] allowed_max');
  _lastGifRenderTime = now;
  return true;
}

// ── Parse [GIF:category] from anywhere in the LLM response ──────────────────
// Returns { gifCategory: string|null, cleanText: string }
export function parseGifFromResponse(text) {
  if (!text) return { gifCategory: null, cleanText: text };
  // Search anywhere in text — LLM may use spaces, mixed case, hyphens, etc.
  const match = text.match(/\[GIF:\s*([^\]]+?)\s*\]/i);
  if (!match) return { gifCategory: null, cleanText: text };
  // Normalize: lowercase + replace spaces with hyphens → matches folder names
  const category = match[1].trim().toLowerCase().replace(/\s+/g, '-');
  if (!GIF_MANIFEST[category]) return { gifCategory: null, cleanText: text };
  // Strip the tag (plus surrounding whitespace/newlines) from displayed text
  const cleanText = text.replace(/\s*\[GIF:\s*[^\]]+\]\s*/gi, ' ').replace(/^\s+|\s+$/g, '');
  return { gifCategory: category, cleanText };
}
